import Presentation from "./presentation";

const Tags = ( { data } ) => {
	return (
		<Presentation data = { data } />
	);
};

export default Tags;